import { ValidationAPIList } from '@/api'
const api = new ValidationAPIList();
export default{
  	getValidationRule({state,commit}, dest ){
  		return new Promise((resolve,reject) =>{
  		api.getValidationRule(dest, (json) => {
        switch (json.status) {
          case 200:
            console.log(json)
            commit('setValidationRule', {data:json.data}); 
            resolve(json);
          break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
        })
  		})
  	},
   validationCheckBeforeSubmit({state,getters,commit,dispatch}, vuexObject = "default"){
    commit('setValidationFinalCheck',{finalCheck:true});
      // let formResult = getters.getFormResult(vuexObject);
      //   console.log(formResult);
      //   return formResult; 
    let result = true;
    let resultObj = state.validationArray[vuexObject];
    setTimeout(()=> {
    // console.log(resultObj);
      // console.log(resultObj.remarks);
     for (var key in resultObj){
      if (!resultObj.hasOwnProperty(key)) continue;
      var obj = resultObj[key];
      // console.log(obj);
      result = result && resultObj[key];
    }
    console.log( 'VuexFinalResult: '+result);
    commit('setValidationFinalResult',{finalResult:result});
    if(!result){
      let msg = state.alertMsg;
      alert(msg);
    }
    }, 200);
   }
}


// WEBPACK FOOTER //
// ./src/Validation/store/actions.js